module.exports = __webpack_public_path__ + "img/Files.b9525181.svg";